import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ListActionBar from '../../../Blocks/Controls/ListActionBar/ListActionBar.jsx'
import { default as DropdownMenu } from '../../../../../../../components/DropdownMenu/DropdownMenu.jsx'
import { IconDetails } from '../../../../../../../svg'

import './Dropdown.scss'

const Dropdown = ({ index, arrayLength, methods }) => {
    const { t } = useTranslation()
    const [items, setItems] = useState([])

    useEffect(() => {
        const _items = !isFirst
            ? [
                  <p className="internal-pages-dropdown__detail" data-icon="rename" onClick={methods.onClickRename}>
                      {t('Rename')}
                  </p>,
                  <ListActionBar
                      className="internal-pages-dropdown__details"
                      index={index}
                      length={arrayLength}
                      upMinIndex={1}
                      isShowLabel
                      onChangePosition={methods.onChangePosition}
                      onClone={methods.onClone}
                      onRemove={methods.onRemove}
                  />,
              ]
            : [
                  <p className="internal-pages-dropdown__detail" data-icon="clone" onClick={methods.onClone}>
                      {t('Clone')}
                  </p>,
              ]
        setItems(_items)
    }, [index, arrayLength, methods])

    const isFirst = index === 0

    return <DropdownMenu className="internal-pages-dropdown" actionHtml={<IconDetails />} items={items} />
}
export default Dropdown
